import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrandProvider} from './common/BrandContext';
import {ContentProvider} from './common/ContentContext';
import {UserProvider} from './common/UserContext';
import {TemplateProvider} from "./common/TemplateContext";
import {ShortcutProvider} from "./common/ShortcutContext";
import {MessageDialogProvider} from './common/MessageDialogContext';

import App from './App';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import {ChTheme} from './common/MuiTheme';
import { ConfigProvider } from "antd";
import {SnackbarProvider} from 'notistack';
import {NavigationProvider} from "./common/NavigationContext";
import {ScreenModeProvider} from "./common/context/ScreenModeContext";

const rootElement = document.getElementById('root');
const shortcutId = rootElement.dataset.shortcutId;
const initSinglePage = rootElement.dataset.singlePage == 'true';
const antDTheme = {
    token: {
        colorTextDisabled: "rgba(0,0,0,0.55)",
        colorTextPlaceholder: "rgba(0,0,0,0.55)",
        colorTextDescription: "rgba(0,0,0,0.88)"
    },
    components: {
        Input: {
            colorBorder: "var(--input-border-colour)",
            colorIcon: "var(--input-border-colour)",
            hoverBorderColor: "var(--input-colour)",
            activeBorderColor: "var(--input-colour)",
        },
        Select: {
            colorBorder: "var(--input-border-colour)",
            colorIcon: "var(--input-border-colour)",
            colorTextQuaternary: "var(--input-border-colour)",
            hoverBorderColor: "var(--input-colour)",
            activeBorderColor: "var(--focus-on-surface)",
            controlOutlineWidth: 1,
            controlOutline: "var(--focus-on-surface)",
            optionSelectedBg: "var(--input-colour)",
            optionSelectedColor: "var(--on-input-colour)",
        },
        Checkbox: {
            colorPrimary: "var(--input-colour)",
            colorBorder: "var(--input-border-colour)",
            hoverBorderColor: "var(--input-colour)",
            activeBorderColor: "var(--input-colour)",
        },
        Radio: {
            colorPrimary: "var(--input-colour)",
            colorBorder: "var(--input-border-colour)",
            hoverBorderColor: "var(--input-colour)",
            activeBorderColor: "var(--input-colour)"
        },
        DatePicker: {
            colorBorder: "var(--input-border-colour)",
            hoverBorderColor: "var(--input-colour)",
            activeBorderColor: "var(--input-colour)",
            colorIcon: "var(--input-border-colour)",
        },
        Table: {
            cellFontSizeSM: "1em",
        },
        Statistic: {
            contentFontSize: "var(--main-font-size)",
        },
    },
    cssVar: {
        key: "ant"
    },
    hashed: false
}
window.buildVersion = process.env.BUILD_VERSION;

const root = createRoot(rootElement);
root.render(
    <ConfigProvider theme={antDTheme}>
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={ChTheme}>
            <BrandProvider>
                <ScreenModeProvider>
                    <ShortcutProvider>
                        <UserProvider>
                            <ContentProvider>
                                <MessageDialogProvider>
                                    <SnackbarProvider maxSnack={1} anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left'
                                    }}>
                                        <TemplateProvider shortcutId={shortcutId} initSinglePage={initSinglePage}>
                                            <NavigationProvider>
                                                <App/>
                                            </NavigationProvider>
                                        </TemplateProvider>
                                    </SnackbarProvider>
                                </MessageDialogProvider>
                            </ContentProvider>
                        </UserProvider>
                    </ShortcutProvider>
                </ScreenModeProvider>
            </BrandProvider>
        </ThemeProvider>
        </StyledEngineProvider>
    </ConfigProvider>
);